
import Badge from 'vux/src/components/badge/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: "",
props: [""],
data() {
return {
wxcode: "",
myUrl: "",
wxconfigdata: {},
apiurl: "",
loginType: "",
};
},

components: {
Badge,
Group,
Cell,
},

created() {},

beforeMount() {},

mounted() {
this.$http.get("./static/api/api.json").then((response) => {
this.apiurl = response.api;
this.myUrl = location.href.split("#")[0];

this.wxcode = this.getUrlCode("code");
this.loginType = localStorage.getItem("login_type");
if (this.loginType === "wx") {
this.getWxJsapiSignature();
} else {
this.zfbScan();
}
});
},
methods: {
getWxJsapiSignature() {

this.wxconfigdata = JSON.parse(
localStorage.getItem("wx_js_api_signature")
);
console.log(this.wxconfigdata);
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: this.wxconfigdata.appId, // 必填，公众号的唯一标识
timestamp: this.wxconfigdata.timestamp, // 必填，生成签名的时间戳
nonceStr: this.wxconfigdata.nonceStr, // 必填，生成签名的随机串
signature: this.wxconfigdata.signature, // 必填，签名
jsApiList: ["scanQRCode", "geoLocation",'openBusinessView'], // 必填，需要使用的JS接口列表 这里填写需要用到的微信api openlocation为使用微信内置地图查看位置接口
});
this.getsys();




















},
zfbScan() {
var _this = this;
ap.scan(function (res) {
var result = res.code;
_this.getscanQrRent(result);
});
},
getsys() {
var _this = this;
wx.ready(function () {
wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function (res) {
var result = res.resultStr; 
_this.getscanQrRent(result);
},
});
});
},
getscanQrRent(result) {
var _this = this;
this.$http
.post(_this.apiurl + "/web/scan", {
qrCodeValue: result,
})
.then((res) => {
if (res.code === 200) {
if (res.data.chargeType === 1) {

if (res.data.paymentFlag === 0) {
_this.$router.push({
name: "payment",
params: {
data: result,
},
});
} else if (res.data.paymentFlag === 1) {

_this.$router.push({
path: "longdings",
query: {
deviceId: res.data.id,
orderId: res.data.orderId,
},
});
} else {

_this.$router.push({
name: "payment",
params: {
data: result,
},
});
}
} else {
if (_this.loginType === "wx") {


if (res.data.paymentFlag === 0) {
_this.$router.push({
name: "paymentfree",
params: {
data: result,
},
});
} else if (res.data.paymentFlag === 1) {


_this.$router.push({
path: "longdings",
query: {
deviceId: res.data.id,
orderId: res.data.orderId,
},
});
} else {

_this.$router.push({
name: "payment",
params: {
data: result,
},
});
}
} else {

_this.$router.push({
path: "longdings",
query: {
deviceId: res.data.id,
orderId: res.data.orderId,
},
});
}
}
} else {
const _this = this; 
this.$vux.confirm.show({
content: res.msg,
cancelText: "退出",
confirmText: "重试",
onCancel() {
if (_this.loginType == "wx") {
ap.popWindow();
} else {
window.close();
}
},
onConfirm() {
if (_this.loginType == "wx") {
_this.getsys();
} else {
this.zfbScan();
}
},
});
}
});
},
getcreateOrder(id, paymentFlag) {
var _this = this;
_this.loading = true;
const psotData = {
deviceId: id,
paymentFlag: paymentFlag,
};
_this.$http
.post(_this.apiurl + "/web/depositOrder/create", psotData)
.then((res) => {
if (res.code == 200) {
const div = document.createElement("div");
div.innerHTML = res.data; 
document.body.appendChild(div);
document.forms[0].submit();
} else {
_this.$vux.toast.text(res.msg, "top");
}
});
},

getUrlCode(name) {
return (
decodeURIComponent(
(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
location.href
) || [, ""])[1].replace(/\+/g, "%20")
) || null
);
},
},

watch: {},
};



// WEBPACK FOOTER //
// ./src/components/scan.vue